exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2VXkhFCvBZqqIELnyCG3FQ{margin:8px 0}html[dir] ._2VXkhFCvBZqqIELnyCG3FQ:last-child{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_2VXkhFCvBZqqIELnyCG3FQ"
};